import { ComponentPropsWithRef } from "react";
import { shade0, shade900 } from "../../../../styles/tokens";

export const PendingIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="24" cy="24" r="24" fill={shade900} />
    <rect x="12" y="21" width="24" height="6" rx="0.75" fill={shade0} />
  </svg>
);
